import request from '@/utils/request';

/**
 * 登录相关 API
 */
export function login(data) {
    return request({
        url: '/login/mobile',
        method: 'post',
        data
    });
}

// 登出
export function logout(data) {
    return request({
        url: '/profile/logout',
        method: 'post',
        data
    });
}

export function send_code(data) {
    return request({
        url: '/login/send_code',
        method: 'post',
        data
    });
}

// 检测手机号是否新用户，返回 result.invite_code 是否需要填写邀请码
export function check_mobile_exist(data) {
    return request({
        url: '/login/check_mobile_exist',
        method: 'post',
        data
    });
}

export function profile_index(data) {
    return request({
        url: '/profile/index',
        method: 'post',
        data
    });
}

export function set_nickname(data) {
    return request({
        url: '/profile/set_nickname',
        method: 'post',
        data
    });
}

export function base_list(data) {
    return request({
        url: '/profile/base_list',
        method: 'post',
        data
    });
}

export function save_base(data) {
    return request({
        url: '/profile/save_base',
        method: 'post',
        data
    });
}

export function check_login_status(data) {
    return request({
        url: '/login/check_login_status',
        method: 'post',
        data
    });
}

export function voice_list(data) {
    return request({
        url: '/profile/voice_list',
        method: 'post',
        data
    });
}

export function enable_voice(data) {
    return request({
        url: '/profile/enable_voice',
        method: 'post',
        data: data
    })
}

export function share_chat(data) {
    return request({
        url: '/profile/share_chat',
        method: 'post',
        data: data
    })
}

export function set_avatar(data) {
    return process.env.VUE_APP_BASE_API + '/profile/set_avatar'
}

